module.exports = __webpack_public_path__ + "static/media/blue-loader.dd94cd23.svg";